import CoreComponent from '../../core/CoreComponent.vue';
import { isMobile } from '@/utils';
export default {
  extends: CoreComponent,
  mounted() {
    const cardImages = this.cmpEl.querySelectorAll('.cmp-hero__bgImage .cmp-hero__bgImage-img');
    cardImages.forEach(image => {
      const card = image.closest('.cmp-hero__bgImage');
      const firstCtaElement = card?.querySelector('.cmp-hero__button a');
      if (firstCtaElement && !isMobile()) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', () => {
          firstCtaElement.click();
        });
      }
    });
  }
};